document.addEventListener("DOMContentLoaded", function () {
 
 // 懒加载
    // 处理图片懒加载
    const lazyImages = document.querySelectorAll("img[data-src]");
    const imgObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                img.removeAttribute("data-src");
                observer.unobserve(img);
            }
        });
    }, {
        rootMargin: '0px 0px 600px 0px'
    });

    lazyImages.forEach(img => {
        imgObserver.observe(img);
    });

// 获取所有懒加载的视频
const lazyVideos = document.querySelectorAll("video.lazyload");

// 创建 IntersectionObserver
const videoObserver = new IntersectionObserver(
    (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const video = entry.target;

                // 获取 video 的 data-src 属性
                const videoSrc = video.dataset.src;
                console.log(videoSrc);
                
                if (videoSrc) {
                    video.src = videoSrc; // 为 video 设置 src
                    video.removeAttribute("data-src"); // 移除 data-src 属性
                }

                // 加载视频
                video.load();

                // 延迟播放，确保视频已加载
                video.onloadeddata = () => {
                    video.play().catch((err) => console.log("Video play error:", err));
                };

                // 停止观察
                observer.unobserve(video);
            }
        });
    },
    {
        rootMargin: "0px 0px 600px 0px", // 提前加载区域
    }
);

// 为每个视频绑定观察器
lazyVideos.forEach((video) => {
    videoObserver.observe(video);
});






const tabs = document.querySelectorAll(".optisolex_page1_section7_tab_text");
const images = document.querySelectorAll(".optisolex_page1_section7_midea_img");
const texts = document.querySelectorAll(".optisolex_page1_section7_text");
const tabLoaders = document.querySelectorAll(".optisolex_page1_section7_tab_load");

let currentIndex = 0; // 当前激活的索引
const intervalTime = 5000; // 自动轮播时间间隔

// 初始化过渡效果
images.forEach((img) => (img.style.transition = "opacity 0.5s ease-in-out"));
texts.forEach((text) => (text.style.transition = "opacity 0.5s ease-in-out"));

// 切换到指定索引的 Tab
function activateTab(index) {
    // 移除所有元素的 active 类
    images.forEach((img) => img.classList.remove("activeimg"));
    texts.forEach((text) => text.classList.remove("activeimg"));
    tabLoaders.forEach((loader) => loader.classList.remove("activeimg"));

    // 为当前索引的元素添加 activeimg 类
    images[index].classList.add("activeimg");
    texts[index].classList.add("activeimg");
    tabLoaders[index].classList.add("activeimg");
}

// 手动切换 Tab
tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
        currentIndex = index; // 更新当前索引
        activateTab(index); // 激活对应内容
    });
});

// 自动切换 Tab
setInterval(() => {
    currentIndex = (currentIndex + 1) % tabs.length; // 循环索引
    activateTab(currentIndex);
}, intervalTime);

// 初始化：显示第一个 Tab 内容
activateTab(currentIndex);



const section6tabs = document.querySelectorAll('.optisolex_page2_section6_tab');
const section6Products = document.querySelectorAll('.optisolex_page2_section6_tab_product');
const arrow = document.querySelectorAll('.optisolex_page2_section6_tab_jiantuo');
const contentPo  = document.querySelectorAll('.optisolex_page2_section6_content_po');  
// 遍历每个 tab 盒子，添加点击事件
section6tabs.forEach((tab, index) => {
  tab.addEventListener('click', () => {
    // 首先清除所有 tab 和 product 的 active 类
    section6tabs.forEach((t) => {
      t.classList.remove('active');
    });

    section6Products.forEach((p) => {
      p.classList.remove('active');
    });
    arrow.forEach((p) => {
      p.classList.remove('rotate');
    });
    contentPo.forEach((p) => {
      p.classList.remove('active');
    });

    // 然后为当前点击的 tab 和对应的 product 添加 active 类
    tab.classList.add('active');
    contentPo[index].classList.add('active');
    section6Products[index].classList.add('active');
    arrow[index].classList.add('rotate');
  });
});





window.addEventListener('scroll', function () {
  const backToTopButton = document.querySelector('.back_to_top');

  if (window.scrollY > 1000) {
      backToTopButton.classList.add('show'); // 显示按钮
  } else {
      backToTopButton.classList.remove('show'); // 隐藏按钮
  }
});


// JavaScript部分
document.onscroll = function (event) {
  const subscribeSections = document.querySelectorAll('.optisolex_section2');
  const topEmail = document.querySelector('.optisolex_section_topemail');
  if (isElementInViewport(subscribeSections[0]) || isElementInViewport(subscribeSections[1])) {
      topEmail.style.transform = 'translateY(-100%)'; 
  } else {
      topEmail.style.transform = 'translateY(0%)'; 
  }
  if (window.scrollY <=20 ) {
    topEmail.style.transform = 'translateY(-100%)'; 
  }
};
function isElementInViewport(el) {
    if(!el){
        return false;
    }
  const rect = el.getBoundingClientRect();
  return rect.bottom > 0 && rect.top < window.innerHeight;
}




})